module.exports = __webpack_public_path__ + "img/pole-blue.b6d202e8.webp";